import { HOST } from "../constants/HostConstants";
export const propertyUpdate = async (
  propertyData,
  features,
  user_id,
  uploadedItems
) => {
  try {
    const response = await fetch(`${HOST}/api/property/propertyUpdate`, {
      method: "POST",
      body: JSON.stringify({
        propertyData,
        features,
        user_id,
        uploadedItems,
      }),
      credentials: "include",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
      },
    });

    const text = await response.text();
    let data = null;
    try {
      data = text ? JSON.parse(text) : null;
    } catch (parseErr) {
      return {
        success: false,
        error: `Invalid server response: ${text?.slice(0, 200) || ""}`,
      };
    }

    if (!response.ok) {
      return {
        success: false,
        error:
          data?.message || data?.error || `Server error (${response.status})`,
      };
    }

    return { success: true, data };
  } catch (error) {
    return { success: false, error: error.message };
  }
};
